import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const modalHeaderFn = /* @__PURE__ */ createRecipe('modalHeader', {}, [])

const modalHeaderVariantMap = {}

const modalHeaderVariantKeys = Object.keys(modalHeaderVariantMap)

export const modalHeader = /* @__PURE__ */ Object.assign(memo(modalHeaderFn), {
  __recipe__: true,
  __name__: 'modalHeader',
  raw: (props) => props,
  variantKeys: modalHeaderVariantKeys,
  variantMap: modalHeaderVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, modalHeaderVariantKeys)
  },
})